import { Row, Col } from "antd";

import styles from "./styles.module.scss";

const GlobalTermsAndConditions = ({
	data,
	communityName,
}: {
	data?: any;
	communityName?: string;
}) => {
	return (
		<div className={styles.content}>
			<div className={styles.title}>
				{communityName ? communityName : "UGENIE"}
			</div>
			<div className={styles.subTitle}>PLATFORM TERMS AND CONDITIONS</div>
			{data ? (
				<Row className={styles.row}>
					<Col span={24} className={styles.normal}>
						<div dangerouslySetInnerHTML={{ __html: data }} />
					</Col>
				</Row>
			) : (
				<>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold} />
						<Col span={23} className={styles.bold}>
							Summary of Ugenie Platform Terms and Conditions
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							1
						</Col>
						<Col span={23} className={styles.bold}>
							About Ugenie
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							Ugenie Ltd provides a community engagement platform
							that may be white-labelled by organisations. By
							using Ugenie, you agree to these Terms. If you don’t
							agree, please don’t use the service.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							2
						</Col>
						<Col span={22} className={styles.bold}>
							Who Can Use It?
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							You must be 18 or older. We do not allow minors and
							use checks to enforce this. If you suspect an
							underage user, contact us.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							3
						</Col>
						<Col span={22} className={styles.bold}>
							Using the Platform
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							Use Ugenie for personal or authorised
							business/community purposes.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							Do not resell, copy, or misuse our content without
							permission.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							4
						</Col>
						<Col span={22} className={styles.bold}>
							Your Content & Intellectual Property
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							You own your content, but you grant us a licence to
							use it on the platform.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							Public content may be seen by others—keep it lawful
							and respectful.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							5
						</Col>
						<Col span={22} className={styles.bold}>
							Acceptable Use
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							No illegal, harmful, misleading, or abusive
							activity.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							We may monitor and remove content or accounts that
							break these rules.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							6
						</Col>
						<Col span={22} className={styles.bold}>
							Data & Privacy
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							We comply with UK GDPR and other data laws.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							You can request access, deletion, or portability of
							your data by contacting us.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							7
						</Col>
						<Col span={22} className={styles.bold}>
							Payments
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							Ugenie does not charge users directly.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							If you pay to access a community, payments are
							managed by the community owner, not Ugenie.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							8
						</Col>
						<Col span={22} className={styles.bold}>
							App Stores
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							If you download Ugenie via Apple, Google Play, etc.,
							their terms also apply.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							Refunds must be requested through the app store
							provider.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							9
						</Col>
						<Col span={22} className={styles.bold}>
							Account Termination
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							We may suspend or terminate accounts for breaches of
							these Terms.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							You can appeal within 14 days.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							10
						</Col>
						<Col span={22} className={styles.bold}>
							Legal
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							We are not liable for indirect damages.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							Ugenie content does not replace professional advice.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							These Terms are governed by English law (with
							arbitration options for U.S. users).
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							11
						</Col>
						<Col span={22} className={styles.bold}>
							Third-Party & User Content Disclaimer
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							The platform may include content submitted by users
							or white-label operators. Ugenie does not moderate,
							verify, or endorse such content and is not liable
							for its legality, accuracy, or reliability.
							Responsibility for such content lies with those who
							post it.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							12
						</Col>
						<Col span={22} className={styles.bold}>
							Contact Us
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							Email:{" "}
							<a href="mailto:info@ugenie.io">info@ugenie.io</a>
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.bold} />
						<Col span={22} className={styles.normal}>
							Address: Ugenie Ltd, 5 Gunnersbury Crescent, London,
							W39AA
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold} />
						<Col span={23} className={styles.bold}>
							FULL UGENIE PLATFORM TERMS AND CONDITIONS
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold} />
						<Col span={23} className={styles.bold}>
							Last Updated: June 2025
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							1
						</Col>
						<Col span={23} className={styles.bold}>
							Introduction
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							1.1
						</Col>
						<Col span={22} className={styles.normal}>
							These Terms and Conditions ("Terms") constitute a
							legally binding agreement between you and Ugenie Ltd
							("we", "us" or "our") and govern your access to and
							use of our community platform, including any branded
							or white-labelled versions operated under licence by
							our clients (the "Platform"), whether accessed via
							web browser, mobile application, or other supported
							interfaces.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							1.2
						</Col>
						<Col span={22} className={styles.normal}>
							Ugenie Ltd is a company registered in England and
							Wales (Company No. 09966790) with a registered
							office at 5 Gunnersbury Crescent, London, W39AA.
							Ugenie Ltd is registered with the UK Information
							Commissioner’s Office (ICO) under registration
							number ZA529959 as a data controller. Where the
							Platform is white-labelled, Ugenie acts as a data
							processor on behalf of the Community operator, who
							is the data controller and bears primary
							responsibility for user data and compliance. For
							clarity, white-label clients are solely responsible
							for their users’ compliance with these Terms.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							1.3
						</Col>
						<Col span={22} className={styles.normal}>
							"You" means the individual using or accessing the
							Platform and includes users of white-labelled
							community platforms managed by our client
							organisations.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							1.4
						</Col>
						<Col span={22} className={styles.normal}>
							By accessing or using the Platform, you agree to be
							bound by these Terms. If you do not agree, you must
							not access or use the Platform. For U.S. users in
							states requiring arbitration opt-outs (e.g., New
							Jersey), disputes relating to your use of the
							Platform (excluding intellectual property or data
							protection disputes) may be resolved through binding
							arbitration in London under LCIA Rules. To opt out,
							email{" "}
							<a href="mailto:info@ugenie.io">info@ugenie.io</a>{" "}
							within 30 days of account creation.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							1.5
						</Col>
						<Col span={22} className={styles.normal}>
							The Platform may contain content submitted by users
							or community operators over which Ugenie Ltd has no
							editorial control. Ugenie Ltd does not moderate,
							verify, or endorse any user-generated or
							community-managed content, and expressly disclaims
							all responsibility and liability arising from such
							content. Where the Platform is operated under a
							white-label licence, the licensed operator is solely
							responsible for moderation, content accuracy, legal
							compliance, and user management.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							1.6
						</Col>
						<Col span={22} className={styles.normal}>
							The Platform uses essential and analytics cookies to
							provide, secure, and improve its services. Where
							required by law, your consent is obtained via a
							cookie banner. Details are provided in our Privacy
							and Cookie Policy. For EU/UK users, we comply with
							the GDPR and PECR.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal} />
						<Col span={22} className={styles.normal}>
							Our privacy policy can be found here:{" "}
							<a href="https://members.ugenie.io/privacy-policy">
								https://members.ugenie.io/privacy-policy
							</a>
							.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal} />
						<Col span={22} className={styles.normal}>
							Our cookie policy can be found here:{" "}
							<a href="https://members.ugenie.io/cookie-policy">
								https://members.ugenie.io/cookie-policy
							</a>
							.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							1.7
						</Col>
						<Col span={22} className={styles.normal}>
							You must be at least 18 years of age to use the
							Platform. The Platform is not targeted toward,
							marketed to, or intended for use by anyone under the
							age of 18. We do not knowingly collect data from
							minors. Underage accounts will be terminated. We
							employ proactive age-verification measures
							(including ID checks for paid communities) and may
							request proof of age. Underage users will be removed
							and their data deleted in accordance with the UK
							Age-Appropriate Design Code and the U.S. Children's
							Online Privacy Protection Act (COPPA). If you
							suspect that an underage user is accessing the
							Platform, please report it to{" "}
							<a href="mailto:info@ugenie.io">info@ugenie.io</a>.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							2
						</Col>
						<Col span={23} className={styles.bold}>
							Intellectual Property
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							2.1
						</Col>
						<Col span={22} className={styles.normal}>
							The Platform contains content which is owned by or
							licensed to us ("Ugenie Content"). This includes,
							but is not limited to, information, design, layout,
							look, appearance, and graphics. You must retain, and
							must not delete or remove, all copyright and
							proprietary notices placed by us.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							2.2
						</Col>
						<Col span={22} className={styles.normal}>
							All intellectual property rights in the Platform and
							its core technology (including backend
							infrastructure and proprietary algorithms) are owned
							by Ugenie Ltd. Where the Platform is white-labelled
							for a third-party organisation, branding and content
							may be provided under licence.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							2.3
						</Col>
						<Col span={22} className={styles.normal}>
							You are granted a limited, non-transferable,
							non-exclusive, revocable licence to use the Platform
							for lawful purposes, subject to these Terms.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							2.4
						</Col>
						<Col span={22} className={styles.normal}>
							Except as expressly permitted, you may not: a. copy,
							reproduce, modify, or adapt Platform content; b.
							sell, rent, or exploit content commercially; c.
							remove, obscure, or alter copyright or trademark
							notices.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							2.5
						</Col>
						<Col span={22} className={styles.normal}>
							We reserve the right to restrict or revoke access to
							the Platform at our sole discretion.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							3
						</Col>
						<Col span={23} className={styles.bold}>
							Licence to use the Platform
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							3.1
						</Col>
						<Col span={22} className={styles.normal}>
							You may: a. view pages from the Platform in a web
							browser or mobile app; b. download pages from the
							Platform for caching in a web browser or mobile app;
							c. print pages from the Platform,
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal} />
						<Col span={22} className={styles.normal}>
							subject always to these Terms, and for your personal
							or authorised business use (e.g., managing or
							participating in communities), in compliance with
							applicable export control laws (e.g., the UK Export
							Control Order 2008, US EAR/ITAR). Use of the
							Platform for broader commercial exploitation (e.g.,
							resale or republishing of Ugenie content) is
							prohibited without our prior written consent.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							3.2
						</Col>
						<Col span={22} className={styles.normal}>
							Except as expressly permitted in Clause 3.1, you
							must not download or save Ugenie Content to your
							device.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							3.3
						</Col>
						<Col span={22} className={styles.normal}>
							You must not edit or modify any Ugenie Content
							except as expressly permitted by Platform
							functionality.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							3.4
						</Col>
						<Col span={22} className={styles.normal}>
							Unless you own or control the relevant rights, you
							must not: a. republish Platform material (other than
							permitted social media extracts); b. sell, rent, or
							sub-license material from the Platform; c. show any
							material from the Platform in public; d. exploit any
							Platform material commercially (other than as a
							registered seller); e. redistribute material except
							under fair use/fair dealing or with our prior
							written consent.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							3.5
						</Col>
						<Col span={22} className={styles.normal}>
							We reserve the right to restrict access to certain
							areas or features of the Platform at our discretion.
							You must not circumvent or attempt to bypass any
							access restriction mechanisms.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							4
						</Col>
						<Col span={23} className={styles.bold}>
							Acceptable use
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							4.1
						</Col>
						<Col span={22} className={styles.normal}>
							You must not: a. use the Platform in any way that
							causes, or may cause, damage to the Platform or
							restrict its availability; b. use the Platform for
							any unlawful, illegal, fraudulent, or harmful
							purpose or activity; c. use the Platform to transmit
							or distribute malicious software; d. engage in data
							scraping, mining, or harvesting without our written
							consent, except via authorised API access; e. post
							content in violation of the UK Online Safety Act
							2023 or applicable U.S. state laws. This includes
							AI-generated content that is misleading or violates
							Clause 7.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							4.2
						</Col>
						<Col span={22} className={styles.normal}>
							All information you supply via the Platform must be
							true, accurate, current, and not misleading.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							4.3
						</Col>
						<Col span={22} className={styles.normal}>
							Illegal content will be promptly removed upon
							notification. Repeat violators may have their
							accounts terminated and may be reported to law
							enforcement. Users may appeal moderation decisions
							by contacting{" "}
							<a href="mailto:info@ugenie.io">info@ugenie.io</a>{" "}
							within 14 days.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							5
						</Col>
						<Col span={23} className={styles.bold}>
							Use on Behalf of an Organisation
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							5.1
						</Col>
						<Col span={22} className={styles.normal}>
							If you use the Platform on behalf of a business or
							other organisation, you represent and warrant that
							you have the authority to bind both yourself and
							that organisation to these Terms. The organisation
							agrees to indemnify Ugenie Ltd for any breach of
							these Terms by its authorised users under the
							principle of vicarious liability, including for
							white-label community operators.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							5.2
						</Col>
						<Col span={22} className={styles.normal}>
							If you are a Community Manager, you are responsible
							for ensuring compliance with these Terms by all
							users within your community.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							6
						</Col>
						<Col span={23} className={styles.bold}>
							Your Content Licence
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							6.1
						</Col>
						<Col span={22} className={styles.normal}>
							In these Terms, "your personal content" refers to
							all works and materials (including text, graphics,
							images, audio, video, scripts, software, and files)
							that you submit to the Platform for storage,
							publication, or processing as part of your Community
							participation.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							6.2
						</Col>
						<Col span={22} className={styles.normal}>
							You grant us a worldwide, irrevocable,
							non-exclusive, royalty-free licence to process,
							store, publish, and distribute your personal content
							solely for the purposes of and within your
							Community, subject to our Privacy Policy. This is in
							line with GDPR Article 6(1)(b) (contractual
							necessity) and CCPA 'business purpose' exemptions.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							6.3
						</Col>
						<Col span={22} className={styles.normal}>
							You may edit your personal content where Platform
							functionality permits.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							6.4
						</Col>
						<Col span={22} className={styles.normal}>
							Your public content" means content submitted to the
							Platform not restricted to your Community and
							visible to broader audiences, including any
							AI-generated content which must be clearly labeled
							if potentially misleading.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							6.5
						</Col>
						<Col span={22} className={styles.normal}>
							You grant us a worldwide, irrevocable,
							non-exclusive, royalty-free licence to use,
							reproduce, store, adapt, publish, and distribute
							your public content in any media and on current or
							future versions of the Platform.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							6.6
						</Col>
						<Col span={22} className={styles.normal}>
							You grant us the right to sub-license the rights
							licensed under Clause 6.5.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							6.7
						</Col>
						<Col span={22} className={styles.normal}>
							You grant to us the right to bring an action for
							infringement of the rights licensed under Clause
							6.5.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							6.8
						</Col>
						<Col span={22} className={styles.normal}>
							You hereby waive all your moral rights in your
							public content to the maximum extent permitted by
							applicable law; and you warrant and represent that
							all other moral rights in your content have been
							waived to the maximum extent permitted by applicable
							law.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							6.9
						</Col>
						<Col span={22} className={styles.normal}>
							You may edit your public content to the extent
							permitted using the editing functionality made
							available on our Platform.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							6.10
						</Col>
						<Col span={22} className={styles.normal}>
							Without prejudice to our other rights under these
							Terms, if you breach any provision of these Terms in
							any way, or if we reasonably suspect that you have
							breached these Terms in any way, we may delete,
							unpublish or edit any or all of your public content.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							7
						</Col>
						<Col span={23} className={styles.bold}>
							Your Content Rules
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal} />
						<Col span={22} className={styles.normal}>
							Disclaimer: The Platform contains content submitted
							by users and community operators. Ugenie Ltd does
							not create, moderate, or endorse any such content,
							and we do not guarantee its accuracy, legality, or
							compliance. Responsibility for user-submitted
							content rests solely with the users or operators who
							post it. We expressly disclaim all liability arising
							from user content, including any material that is
							unlawful, offensive, misleading, or otherwise in
							breach of these Terms.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							7.1
						</Col>
						<Col span={22} className={styles.normal}>
							You warrant and represent that your public and
							personal content will comply with these Terms and
							Conditions.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							7.2
						</Col>
						<Col span={22} className={styles.normal}>
							Your content must not be illegal or unlawful, must
							not infringe any person's legal rights, and must not
							be capable of giving rise to legal action against
							any person (in each case in any jurisdiction and
							under any applicable law).
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							7.3
						</Col>
						<Col span={22} className={styles.normal}>
							Your content, and the use of your content by us in
							accordance with these Terms, must not: a. be
							libellous or maliciously false; b. be obscene or
							indecent; c. infringe any copyright, moral right,
							database right, trade mark right, design right,
							right in passing off, or other intellectual property
							right; d. infringe any right of confidence, right of
							privacy or right under data protection legislation;
							e. constitute negligent advice or contain any
							negligent statement; f. constitute or promote any
							criminal activity; g. be in contempt of any court,
							or in breach of any court order; h. be in breach of
							racial or religious hatred or discrimination
							legislation; i. be blasphemous; j. be in breach of
							any contractual obligation owed to any person; k. be
							untrue, false, inaccurate or misleading; l. contain
							any instructions, advice or other information which
							may be acted upon and could, if acted upon, cause
							illness, injury or death, or any other loss or
							damage; m. constitute spam; n. be offensive,
							deceptive, fraudulent, threatening, abusive,
							harassing, anti-social, menacing, hateful,
							discriminatory or inflammatory.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							7.4
						</Col>
						<Col span={22} className={styles.normal}>
							The Community you join may allow you to send
							messages to other users of the Platform. You agree
							that Ugenie may terminate your permission to send
							messages at any time and for any reason, without
							notice or liability to you. If you receive an
							objectionable message from another user, please
							notify your Community manager, and/or send us an
							e-mail to{" "}
							<a href="mailto:info@ugenie.io">info@ugenie.io</a>.
							You agree that Ugenie may monitor Community messages
							for compliance with these Terms.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							8
						</Col>
						<Col span={23} className={styles.bold}>
							Breaches of these terms and conditions
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							8.1
						</Col>
						<Col span={22} className={styles.normal}>
							Without prejudice to our other rights under these
							Terms and Conditions, if you breach these Terms and
							Conditions in any way, or if we reasonably suspect
							that you have breached these Terms and Conditions in
							any way, we may: a. send you one or more formal
							warnings; b. temporarily suspend your access to our
							Platform; c. permanently prohibit you from accessing
							our Platform; d. block computers using your IP
							address from accessing our Platform; e. contact any
							or all of your internet service providers and
							request that they block your access to our Platform;
							f. commence legal action against you, whether for
							breach of contract or otherwise; and/or g. suspend
							or delete your account on our Platform.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							8.2
						</Col>
						<Col span={22} className={styles.normal}>
							Users may appeal any enforcement action by
							contacting{" "}
							<a href="mailto:info@ugenie.io">info@ugenie.io</a>{" "}
							within 14 days of notification.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							9
						</Col>
						<Col span={23} className={styles.bold}>
							Third-Party Websites
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							9.1
						</Col>
						<Col span={22} className={styles.normal}>
							Our Platform may include links to other websites or
							apps owned and operated by third parties. We have no
							responsibility for the content of such third party
							websites or apps.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							9.2
						</Col>
						<Col span={22} className={styles.normal}>
							We have no control over third party websites or apps
							and their contents, and we accept no responsibility
							for them or for any loss or damage that may arise
							from your use of them. Ugenie is not responsible for
							the content or services of third parties. Accessing
							third-party sites is at your own risk. Inclusion of
							links does not imply endorsement. You should review
							the privacy and terms policies of any third-party
							services you access via links from our Platform.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							10
						</Col>
						<Col span={23} className={styles.bold}>
							Trademarks
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							10.1
						</Col>
						<Col span={22} className={styles.normal}>
							All trademarks, logos, and brand names on the
							Platform are the property of their respective
							owners. Use without permission is strictly
							prohibited.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							11
						</Col>
						<Col span={23} className={styles.bold}>
							Copyright Complaints
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							11.1
						</Col>
						<Col span={22} className={styles.normal}>
							If you believe that your intellectual property is
							being violated on the Platform, you can submit a
							complaint and request for takedown of specific
							material at:{" "}
							<a href="mailto:info@ugenie.io">info@ugenie.io</a>.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							11.2
						</Col>
						<Col span={22} className={styles.normal}>
							The Digital Millennium Copyright Act of 1998 (the
							"DMCA") protects the rights of copyright owners who
							believe that material appearing on the internet
							infringes their rights under U.S. copyright law. If
							you believe in good faith that materials posted on
							the Services infringe your copyright, you (or your
							agent) may send Ugenie a "Notice of Claimed
							Infringement" at{" "}
							<a href="mailto:info@ugenie.io">info@ugenie.io</a>{" "}
							requesting that the material be removed. The Notice
							must include the following information: a. a
							physical or electronic signature of a person
							authorized to act on behalf of the owner of the
							works that have been allegedly infringed; b.
							identification of the copyrighted work alleged to
							have been infringed; c. identification of the
							specific material alleged to be infringing; d. your
							contact information; e. a statement of good faith
							belief; and f. a statement of accuracy under penalty
							of perjury.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							11.3
						</Col>
						<Col span={22} className={styles.normal}>
							UK copyright claims may also be filed under the
							Copyright, Designs and Patents Act 1988. False
							claims may result in liability.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							12
						</Col>
						<Col span={23} className={styles.bold}>
							App Store Terms
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							12.1
						</Col>
						<Col span={22} className={styles.normal}>
							If you are accessing the Platform on an iOS-based
							device, you agree to and acknowledge the following
							terms:
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							(a)
						</Col>
						<Col span={22} className={styles.normal}>
							You acknowledge that these Terms are between you and
							Ugenie only, not with Apple, and Apple is not
							responsible for any App or the content thereof.
							Apple has no obligation whatsoever to furnish any
							maintenance and support services with respect to any
							App. In the event of any failure of any App to
							conform to any applicable warranty, then you may
							notify Apple and request that Apple refund the
							purchase price for the relevant App to you; and, to
							the maximum extent permitted by applicable law,
							Apple has no other warranty obligation whatsoever
							with respect to any App. Apple is not responsible
							for addressing any claims by you or any third party
							relating to any App or your possession and/or use of
							any App, including, but not limited to: i. product
							liability claims; ii. any claim that any App fails
							to conform to any applicable legal or regulatory
							requirement; and iii. claims arising under consumer
							protection or similar legislation.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							(b)
						</Col>
						<Col span={22} className={styles.normal}>
							Apple is not responsible for the investigation,
							defense, settlement, and discharge of any third
							party claim that any App or your possession and use
							of any App infringes that third party’s intellectual
							property rights. You will comply with any applicable
							third-party terms, when using any App. Apple, and
							Apple’s subsidiaries, are third-party beneficiaries
							of this section of these Terms, and upon your
							acceptance of these Terms, Apple will have the right
							(and will be deemed to have accepted the right) to
							enforce this section of these Terms against you as a
							third-party beneficiary of these Terms.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							(c)
						</Col>
						<Col span={22} className={styles.normal}>
							You hereby represent and warrant that: i. you are
							not located in a country that is subject to a U.S.
							Government embargo, or that has been designated by
							the U.S. Government as a “terrorist supporting”
							country; and ii. you are not listed on any U.S.
							Government list of prohibited or restricted parties.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							13
						</Col>
						<Col span={23} className={styles.bold}>
							Google Play and Other App Stores
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							13.1
						</Col>
						<Col span={22} className={styles.normal}>
							If you access the Platform via Google Play, Amazon
							Appstore, Huawei AppGallery, Samsung Galaxy Store,
							or any other mobile app store:
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							a.
						</Col>
						<Col span={22} className={styles.normal}>
							These Terms are solely between you and Ugenie – the
							app store provider is not a party; b. You must
							comply with the app store’s terms of service; c. The
							app store provider has no obligation to provide
							maintenance/support; d. You confirm compliance with
							all applicable export control laws; e. Requests for
							refunds must be made directly to the respective app
							store in accordance with their policies.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							14
						</Col>
						<Col span={23} className={styles.bold}>
							Termination
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							14.1
						</Col>
						<Col span={22} className={styles.normal}>
							We may suspend or terminate accounts for breaches of
							these Terms, with 14-day appeal rights via
							<a href="mailto:info@ugenie.io">info@ugenie.io</a>.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							14.2
						</Col>
						<Col span={22} className={styles.normal}>
							EU users may request data portability under GDPR
							Article 20 before termination. Other users may
							contact us for data retrieval options where legally
							required.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							14.3
						</Col>
						<Col span={22} className={styles.normal}>
							Following account termination, your data will be
							retained or deleted in accordance with our Privacy
							Policy and applicable law.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							15
						</Col>
						<Col span={23} className={styles.bold}>
							Indemnity
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							15.1
						</Col>
						<Col span={22} className={styles.normal}>
							You agree to indemnify Ugenie Ltd, its affiliates,
							and partners against claims, losses, damages, and
							costs (including legal fees) arising from:
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							a.
						</Col>
						<Col span={22} className={styles.normal}>
							your use of the Platform; b. content you submit; c.
							your breach of the Terms; or d. actions of
							white-label operators on your behalf.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							16
						</Col>
						<Col span={23} className={styles.bold}>
							General Terms
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							16.1
						</Col>
						<Col span={22} className={styles.normal}>
							If any part of these Terms is found to be invalid or
							unenforceable, the remainder will remain in full
							force and effect.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							16.2
						</Col>
						<Col span={22} className={styles.normal}>
							These Terms supersede all prior agreements and
							understandings relating to your use of the Platform.
							Nothing in these Terms limits liability for
							fraudulent misrepresentation.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							16.3
						</Col>
						<Col span={22} className={styles.normal}>
							We may remove or edit content and disclose user data
							to legal authorities as required by law.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							16.4
						</Col>
						<Col span={22} className={styles.normal}>
							You may not transfer your rights or obligations
							under these Terms without our prior written consent.
							We may assign our rights and obligations without
							notice.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							16.5
						</Col>
						<Col span={22} className={styles.normal}>
							Except as explicitly provided in Clause 12, no third
							party shall have any right to enforce these Terms
							under the Contracts (Rights of Third Parties) Act
							1999.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							16.6
						</Col>
						<Col span={22} className={styles.normal}>
							No waiver of any breach or default under these Terms
							shall be deemed a waiver of any subsequent breach or
							default. All waivers must be in writing.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							16.7
						</Col>
						<Col span={22} className={styles.normal}>
							We may update these Terms from time to time.
							Material changes will be communicated via email or
							in-app notice, where legally required. Continued use
							of the Platform constitutes acceptance of the
							revised Terms.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							16.8
						</Col>
						<Col span={22} className={styles.normal}>
							These Terms are governed by and construed in
							accordance with the laws of England and Wales. For
							U.S. users: a. California, Colorado, and New Jersey
							residents retain specific rights under state law; b.
							All other U.S. users agree to binding arbitration in
							London under Clause 1.4, unless properly opted out.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							17
						</Col>
						<Col span={23} className={styles.bold}>
							Consumer Rights
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							17.1
						</Col>
						<Col span={22} className={styles.normal}>
							UK users retain all statutory rights under the
							Consumer Rights Act 2015.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							17.2
						</Col>
						<Col span={22} className={styles.normal}>
							Ugenie does not charge end users directly for use of
							the Platform. Client-operated paid communities are
							solely responsible for payment processing and refund
							terms.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							17.3
						</Col>
						<Col span={22} className={styles.normal}>
							U.S. users may have additional rights under
							applicable state consumer laws, including: a.
							California Consumer Legal Remedies Act; b. Colorado
							Consumer Protection Act; c. Other state-specific
							digital goods and service regulations.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							18
						</Col>
						<Col span={23} className={styles.bold}>
							Legal Notice
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							18.1
						</Col>
						<Col span={22} className={styles.normal}>
							These Terms constitute a legally binding agreement.
							Jurisdiction-specific exceptions may apply as noted.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							18.2
						</Col>
						<Col span={22} className={styles.normal}>
							The Platform and its content are provided "as is"
							without warranties, except where prohibited by law.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							18.3
						</Col>
						<Col span={22} className={styles.normal}>
							To the fullest extent permitted by law, Ugenie Ltd
							disclaims liability for any indirect, incidental, or
							consequential damages arising from your use of the
							Platform.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}>
							18.4
						</Col>
						<Col span={22} className={styles.normal}>
							The content on the Platform does not constitute
							professional advice. You should consult qualified
							experts for legal, financial, or medical guidance.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={1} className={styles.bold}>
							19
						</Col>
						<Col span={23} className={styles.bold}>
							Contact Us
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}></Col>
						<Col span={22} className={styles.normal}>
							Ugenie Ltd
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}></Col>
						<Col span={22} className={styles.normal}>
							5 Gunnersbury Crescent
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}></Col>
						<Col span={22} className={styles.normal}>
							London, W39AA
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}></Col>
						<Col span={22} className={styles.normal}>
							United Kingdom
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}></Col>
						<Col span={22} className={styles.normal}>
							Email:{" "}
							<a href="mail:info@ugenie.io">info@ugenie.io</a>
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col span={2} className={styles.normal}></Col>
						<Col span={22} className={styles.normal}>
							All contact requests, including GDPR and legal
							notices, should be directed to{" "}
							<a href="mailto:info@ugenie.io">info@ugenie.io</a>
						</Col>
					</Row>
				</>
			)}
		</div>
	);
};

export default GlobalTermsAndConditions;
